<div class="container-fluid pb-4">
  <div class="pb-4">
    <div class="pt-4 pb-2 heading-container">
      <h1 class="d-inline-block align-middle m-0" data-test-id="distribution-page-heading">
        {{ 'DISTRIBUTION_GEOGRAPHIC' | translate }}
      </h1>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <form [formGroup]="form" novalidate>
        <div class="mb-4">
          <div class="form-group">
            <label for="countrySelect" class="form-label"> Choose location view: </label>
            <div
              class="ms-1 custom-tooltip"
              data-test-id="distribution-preferences-tooltip"
              placement="bottom auto"
              triggers="click:blur"
              [ngbTooltip]="'DISTRIBUTION_PREFERENCES_TOOLTIP' | translate"
            >
              <img src="assets/icons/icon-info.svg" alt="info" />
            </div>
            <select
              id="countrySelect"
              class="form-select"
              formControlName="selectedCountry"
              data-test-id="country-select"
            >
              <option
                *ngFor="let option of countryOptions"
                [value]="option.value"
                [attr.data-test-id]="'country-option-' + option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </form>

      <div class="d-inline-flex gap-2">
        <button
          appLongOperation
          class="btn btn-primary text-white"
          type="button"
          data-test-id="save-distribution-preferences-btn"
          [disabled]="!isFormChanged || noRegionalData"
          (click)="savePatientDistributionPreferences()"
        >
          {{ 'BTN_SAVE_HINT' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          data-test-id="discard-distribution-preferences-changes-btn"
          [disabled]="!isFormChanged"
          (click)="discardChanges()"
        >
          {{ 'EXIT_BUTTON_HINT' | translate }}
        </button>
      </div>

      <app-relation-geography
        [relationType]="distributionText"
        [relationGeography]="relationGeography$ | async"
        [noRelationEntitiesLabel]="
          noRegionalData
            ? 'DISTRIBUTION_TAB_PATIENTS_NO_REGIONAL_DATA_AVAILABLE'
            : 'DISTRIBUTION_TAB_PATIENTS_HEADER_NO_PATIENTS_YET'
        "
        [dataTestIdSuffix]="'patients'"
      >
      </app-relation-geography>
    </div>
  </div>
</div>
